import { render, staticRenderFns } from "./SalesOrderDetails.vue?vue&type=template&id=2874b805&scoped=true&"
import script from "./SalesOrderDetails.vue?vue&type=script&lang=ts&"
export * from "./SalesOrderDetails.vue?vue&type=script&lang=ts&"
import style0 from "./SalesOrderDetails.vue?vue&type=style&index=0&id=2874b805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874b805",
  null
  
)

export default component.exports